export enum OrganisationMenuTabs {
    SETTINGS = 'Einstellungen',
    PRODUCTS = 'Produkte',
    PRODUCT_TYPES = 'Produkttypen',
    ATTRIBUTES = 'Merkmale',
    CERTIFICATIONS = 'Zertifikate'
}
